import type { FlowchartTextLayout } from '../../domains/diagram/shapes/flowchartTextLayout';
import { getNodeMutationManager } from './mutations/NodeMutationManager';
import { useDiagramStore } from '../../stores/diagramStore';
import { BaseCommand } from './ICommand';

interface FlowchartTextLayoutUpdate {
  nodeId: string;
  layout: FlowchartTextLayout;
}

/**
 * Persists derived Konva line layout without adding a user-visible undo entry.
 * The layout is export metadata, not a user-authored edit.
 */
export class RefreshFlowchartTextLayoutCommand extends BaseCommand {
  constructor(private readonly updates: FlowchartTextLayoutUpdate[]) {
    super('Refresh Flowchart Text Layout', undefined, { skipHistory: true, requiresWriteAccess: true });
  }

  async execute(): Promise<void> {
    const mutationManager = getNodeMutationManager();
    const { nodes, updateNode } = useDiagramStore.getState();

    for (const { nodeId, layout } of this.updates) {
      const node = nodes.find((candidate) => candidate.id === nodeId);
      if (!node || node.type !== 'flowchart-shape') continue;
      const changes = { attrs: { ...(node.attrs ?? {}), flowchartTextLayout: layout } };
      mutationManager.applyNodeChange(nodeId, changes);
      updateNode(nodeId, changes);
    }
  }

  async undo(): Promise<void> {
    // This command is excluded from history because the metadata is derived.
  }
}
